<div class="row">
    <div class="col-lg-12 col-xl-10 offset-xl-1">
     
        <div class="row">
        <div class="col-6 col-lg-6">
            <h4 class="mb-20">Address</h4>
            <div class="card bg-white h-100 w-100 border-0 shadow-sm">
                <div class="card-body p-lg-4">
            <app-address-form
                [initialAddress]="address"
                [mode]="'edit'"
                (validAddress)="validAddressAdded($event)"
                [requiredFields]="{adr1: true, town: true, county: true, postcode: true}"
            ></app-address-form>
        </div>
            </div></div>
           
      <!----  <div class="col-6 col-lg-6">
            <h4 class="mb-20">Collection Address</h4>
            <div class="card bg-white h-100 w-100 border-0 shadow-sm">
                <div class="card-body p-lg-4">
                    <app-collection-address-select 
                    [deliveryAddresses]="deliveryAddresses"
                    [basket]="basket"
                    [userData] ="user"
                    (addressAdded)="addressAdded($event)"></app-collection-address-select>
                  
        </div>
        </div>
        </div>-->
        <div class="row mt-60">
            <div class="col-6">
            </div>
            <div class="col-6 text-end">
                <button [disabled]="!validAddress" type="submit" class="btn btn-round btn-primary" (click)="onSubmit()">
                    Continue
                </button>
            </div>
        </div>
    </div>
</div>
